import { useQuery } from '@tanstack/react-query';

import { GetAverageConsumptionsParams } from '../../../../common/api/clients/consumptions.api';
import { queries } from '../../../../common/api/queryKeys/queries';

export const useAverageConsumption = ({ vesselId, dateFrom, dateTo, resolution }: GetAverageConsumptionsParams) => {
    return useQuery(queries.vessels.detail(vesselId)._ctx.averageConsumption(dateFrom, dateTo, resolution));
};
